module.exports = __webpack_public_path__ + "img/metric-cards.b8d73c75.png";